import { TInternalizationIntegrations } from '@/models/internationalization';
import store from '@/store';

export function countryAcceptSellingCoins() {
  const integrations = store.getters[
    'internationalization/getIntegrations'
  ] as TInternalizationIntegrations;

  return integrations.some(
    integration =>
      integration.provider === 'selling-coins' &&
      integration.status === 'active'
  );
}
